module.exports = __webpack_public_path__ + "media/images/svg/logo-5c206e12df993081e09b4af2f6a25e1c.svg";